<template>
    <v-app id="inspire">
        <router-view name="AppBarMobile" v-if="$mq != 'lg'"></router-view>
        <router-view name="AppBarDesktop" v-else></router-view>
        <router-view name="LeftMenu"></router-view>
        <router-view name="OryxCartResume"></router-view>
        <router-view name="AppMain">
            <router-view></router-view>
        </router-view>
        <router-view name="AppMainCart">
            <router-view></router-view>
        </router-view>
        <router-view name="OryxCartFooter"></router-view>
        <router-view name="AppSnackBar"></router-view>
        <router-view name="AppLoading"></router-view>
        <router-view name="Dialog"></router-view>
        <router-view name="DialogManager"></router-view>
        <router-view name="LoadingFinishSale"></router-view>
        <router-view name="SendNfeMailDialog"></router-view>
        <router-view name="ProductSearch"></router-view>
        <router-view name="DialogFiscalPaf"></router-view>
    </v-app>
</template>

<script>

export default {
    data: () => ({}),
    mounted(){
        this.$store.dispatch("lx0/find")
    }
};
</script>

<style lang="scss">
#inspire {    
    font-family: Muli !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>